import React from "react";
// components
import Page from "../components/Page";
import TabbedPage from "../components/TabbedPage";
import NotificationsList from "./NotificationList";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const NotificationsAll = () => {
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    return (
        <Page title={t('NotificationsAll.pageTitle')}>
            {user && user.is_staff === true ? (
                <TabbedPage>
                    <NotificationsList label={t('NotificationsAll.tabbedPages.new')} category="new" />
                    <NotificationsList label={t('NotificationsAll.tabbedPages.modified')} category="modified" />
                    <NotificationsList
                        label={t('NotificationsAll.tabbedPages.userRequests')}
                        category="users"
                    />
                </TabbedPage>
            ) : (
                <TabbedPage>
                    <NotificationsList label={t('NotificationsAll.tabbedPages.new')} category="new" />
                    <NotificationsList label={t('NotificationsAll.tabbedPages.modified')} category="modified" />
                </TabbedPage>
            )}
        </Page>
    );
};

export default NotificationsAll;
